module.exports = __webpack_public_path__ + "static/media/wellness-1021131_1920.de788583.jpg";